// extracted by mini-css-extract-plugin
module.exports = {"noCanvases":"no-canvases-empty-state-new_noCanvases__Y93e3"};